module.exports = __webpack_public_path__ + "img/nav_left_bottom_img.5b603ed8.png";